<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasReportPermission() {
      return this.currentAccountCan('BGYS_SIDE_BAR__HAS_REPORT_PERMISSION');
    },
    hasLegalDocumentPermission() {
      return this.currentAccountCan('BGYS_SIDE_BAR__HAS_LEGAL_DOCUMENT_PERMISSION');
    },
    hasFileManagerPermission() {
      return this.currentAccountCan('BGYS_SIDE_BAR__HAS_FILE_MANAGER_PERMISSION');
    },
    hasRiskPermission() {
      return this.currentAccountCan('BGYS_SIDE_BAR__HAS_RISK_PERMISSION');
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      widthss: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
    };
  },
  methods: {},
  mounted() {},
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu2 d-flex flex-column" style="background-color: rgb(243, 246, 248);">
    <div class="sidebar--logo">
      <img :src="whiteLabel || require('@/assets/images/logo.png')" height="52" alt="" />
    </div>

    <!-- <a href="/">
      <div class="user-panel" style="padding-left: 2.5rem;">
        <i class="iconoir-view-grid"></i>
        {{ $t("dashboard.text") }}
      </div>
    </a> -->

    <router-link tag="a" to="/bgys/roadmap">
      <div class="menu-item">
        <i class="iconoir-maps-arrow"></i>
        {{ $t("roadmap.bgys.text") }}
      </div>
    </router-link>
    <!--
    <router-link tag="a" to="/bgys/entities">
      <div class="menu-item">
        <i class="iconoir-keyframes"></i>
        {{ $t("entity.plural") }}
      </div>
    </router-link> -->

    <router-link tag="a" to="/bgys/asset-groups">
      <div class="menu-item">
        <i class="iconoir-keyframes"></i>
        {{ $t("asset-group.plural") }}
      </div>
    </router-link>

    <!-- <router-link tag="a" to="/bgys/inventory">
      <div class="menu-item">
        <i class="iconoir-network-right"></i>
        {{ $t("asset-group.inventory.title") }}
      </div>
    </router-link>

    <router-link tag="a" to="/bgys/asset-group/criticality">
      <div class="menu-item">
        <i class="iconoir-activity"></i>
        {{ $t("asset-group.degree-of-criticality") }}
      </div>
    </router-link> -->
    <!-- TKP-147: Soru Setleri ve Tedbirler menüden kalktı (tasarım s.35 md.5,7; s.20 md.4) -->

    <router-link v-if="hasRiskPermission" tag="a" to="/bgys/risk">
      <div class="menu-item">
        <i class="iconoir-shield-alert"></i>
        {{ $t("risk.text") }}
      </div>
    </router-link>

    <router-link tag="a" to="/bgys/application">
      <div class="menu-item">
        <i class="iconoir-bookmark-book"></i>
        {{ $t("application.text") }}
      </div>
    </router-link>

    <!-- <router-link tag="a" to="/bgys/data-breach">
      <div class="menu-item">
        <i class="iconoir-database-warning"></i>
        {{ $t("data-breach.plural") }}
      </div>
    </router-link>

    <router-link v-if="hasLegalDocumentPermission" tag="a" to="/bgys/legal-document-template">
      <div class="menu-item">
        <i class="iconoir-privacy-policy"></i>
        {{ $t("legal-document.plural") }}
      </div>
    </router-link>

-->
    <router-link v-if="hasReportPermission" tag="a" to="/bgys/report">
      <div class="menu-item">
        <i class="iconoir-page"></i>
        {{ $t("report.plural") }}
      </div>
    </router-link>
    <router-link v-if="hasFileManagerPermission" tag="a" to="/bgys/file-manager">
      <div class="menu-item">
        <i class="iconoir-page"></i>
        {{ $t("file-manager.text") }}
      </div>
    </router-link>
    <hr />
    <a href="/">
      <div class="menu-item">
        <i class="iconoir-view-grid"></i>
        {{ $t("dashboard.text") }}
      </div>
    </a>
    <a href="/organization">
      <div class="menu-item">
        <i class="iconoir-cube-hole"></i>
        {{ $t("organization.panel") }}
      </div>
    </a>
    <!-- TKP-118 / tasarım s.24 md.1: Görevler ayrı modül — ürün menüsünden çıktı, modül geçişine taşındı. -->
    <a v-if="hasCurrentOrganizationAccessable('TASKS')" href="/tasks">
      <div class="menu-item">
        <i class="iconoir-archery"></i>
        {{ $t("task.plural") }}
      </div>
    </a>

    <a v-if="hasCurrentOrganizationAccessable('RISK')" href="/risk/dashboard">
      <div class="menu-item">
        <img height="25" src="/icons/risk-active.svg" />
        {{ $t("product.risk.product") }}
      </div>
    </a>
    <a v-if="hasCurrentOrganizationAccessable('GDPR')" href="/gdpr/entities">
      <div class="menu-item">
        <img height="25" src="/icons/gdpr-active.svg" />
        {{ $t("product.gdpr.product") }}
      </div>
    </a>
    <a v-if="hasCurrentOrganizationAccessable('KVKK')" href="/kvkk/entities">
      <div class="menu-item">
        <img height="25" src="/icons/kvkk-active.svg" />
        {{ $t("product.kvkk.product") }}
      </div>
    </a>
    <a v-if="hasCurrentOrganizationAccessable('DDO')" href="/ddo/roadmap">
      <div class="menu-item">
        <img height="25" src="/icons/ddo-active.svg" />
        {{ $t("product.ddo.product") }}
      </div>
    </a>

    <!-- <simplebar v-if="!isCondensed" :settings="settings" class="h-100">
      <SideNav />
    </simplebar>

    <simplebar v-else class="h-100">
      <SideNav />
    </simplebar> -->
  </div>
  <!-- Left Sidebar End -->
</template>

<style lang="scss" scoped>
.user-panel {
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  gap: 1rem;
  color: #707070;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 3.38rem;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  color: #535a71;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  max-width: 15rem;
  width: 100%;
  border-radius: 0.625rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  transition: background-color, color, 0.3s;
  cursor: pointer;

  i {
    position: relative;
    bottom: 1px;
    font-size: 1.5rem;
  }

  &:hover {
    background: #f2e0da;
    color: #ff7c48;

    i {
      color: #ff7c48;
    }
  }
}

.active {
  .menu-item {
    background: #f2e0da;
    color: #ff7c48;

    i {
      color: #ff7c48;
    }
  }
}
</style>
